import { Models, OrderDeliveryStatus, OrderPickupStatus } from "api/types";
import {
  getPastOrderItems,
  getPastOrders,
  getRedeemedEarnedProducts,
} from "utils/retailProducts.helpers";

import { RetailProductPastOrderLineItemCard } from "../index";

export interface RetailProductPastOrdersSectionProps {
  productsOrders: Models<"DisplayRetailProductOrderFromPerson">[];
  retailProductRefunds: Models<"DisplayRetailProductRefundSupportDetailsForOrder">[];
  earnedProducts: Models<"DisplayRetailProductOrderLineItemForPickup">[];
}

export const RetailProductPastOrdersSection = ({
  productsOrders,
  retailProductRefunds,
  earnedProducts,
}: RetailProductPastOrdersSectionProps) => {
  const pastOrders = getPastOrders(productsOrders);
  const redeemedEarnedProducts = getRedeemedEarnedProducts(earnedProducts);

  // Combine both regular past orders and redeemed earned products and show most recent first
  const allPastItems = [
    ...getPastOrderItems(pastOrders),
    ...redeemedEarnedProducts,
  ].sort((a, b) => {
    const dateA = a.completionDate ? new Date(a.completionDate).getTime() : 0;
    const dateB = b.completionDate ? new Date(b.completionDate).getTime() : 0;
    return dateB - dateA;
  });

  if (allPastItems.length === 0) return null;

  return (
    <>
      <h2 className="mb-4 text-sub2 uppercase text-secondary">Past Products</h2>
      <div className="grid grid-cols-1 gap-4">
        {allPastItems.map(
          ({
            orderId,
            lineItem,
            lastRedeemedOnUtc,
            estimatedDeliveryDateAtUtc,
            shipmentTrackingUrl,
          }) => (
            <div
              key={
                orderId
                  ? `${orderId}-${lineItem.packageId}`
                  : `earned-${lineItem.packageId}`
              }
            >
              <RetailProductPastOrderLineItemCard
                thumbnailImageUri={lineItem.thumbnailImageUri || undefined}
                name={lineItem.name.text}
                totalQuantity={lineItem.totalQuantity}
                status={
                  lineItem.status as OrderPickupStatus | OrderDeliveryStatus
                }
                redeemedOnUtc={lastRedeemedOnUtc || undefined}
                estimatedDeliveryDateAtUtc={
                  estimatedDeliveryDateAtUtc || undefined
                }
                shipmentTrackingUrl={shipmentTrackingUrl || undefined}
                orderId={orderId}
                packageId={lineItem.packageId}
                packageListingId={lineItem.packageListingId}
                retailProductRefunds={retailProductRefunds}
              />
            </div>
          )
        )}
      </div>
    </>
  );
};
